import { grey } from '@styles/theme';
import { themeVars } from '@styles/themes.css';
import * as styles from './index.css';

interface Props {
  percent: number;
  className?: string;
}

const BAR_HEIGHT = 8;

const ProgressBar = ({ percent, className }: Props) => {
  const progress = clampToPercentRange(Math.round(percent));

  return (
    <svg
      className={[styles.bar, className].filter(Boolean).join(' ')}
      height={BAR_HEIGHT}
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='progressbar-fill'>
          <stop
            offset='0'
            style={{
              stopColor: themeVars.brandColor.progressbar.gradientStart,
            }}
          />
          <stop
            offset='1'
            style={{ stopColor: themeVars.brandColor.progressbar.gradientEnd }}
          />
        </linearGradient>
      </defs>
      <rect width='100%' height={BAR_HEIGHT} rx='4' fill={grey} />
      <rect
        width={`${progress}%`}
        height={BAR_HEIGHT}
        rx='4'
        fill='url(#progressbar-fill)'
      />
    </svg>
  );
};

const clampToPercentRange = (value: number) =>
  Math.min(100, Math.max(0, value));

export default ProgressBar;
